import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { TEnrichmentsSelection } from '@/features/segments/types';
import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { clipsQueryKeys } from './query-keys';

type TRelaunchClip = {
  id: string;
  enrichments: TEnrichmentsSelection;
};

async function relaunchClip({ id, enrichments }: TRelaunchClip): Promise<unknown> {
  return mediaManagerClient.patch(`/api/v1/clips/${id}/relaunch`, enrichments);
}

type MutationFn = typeof relaunchClip;

type TUseRelaunchClipParams = {
  config?: MutationConfig<MutationFn>;
};

export function useRelaunchClip({ config = {} }: TUseRelaunchClipParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: relaunchClip,
    onError(error) {
      addErrorNotification(
        t('No se han lanzado los enriquecimientos'),
        t('Ha habido un error durante el proceso, vuelva a intentarlo más tarde')
      );
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(
        t('Se han relanzado los enriquecimientos'),
        t('El proceso ha sido un éxito')
      );
      queryClient.invalidateQueries({ queryKey: clipsQueryKeys.all });
    },
  });
}
